export default __webpack_public_path__ + "static/media/logo_tib.2727ebb0.png";